import React from 'react'
import { StyleSheet, Text, View } from '@react-pdf/renderer'

const styles = StyleSheet.create({

  addressContainer: {
    flexDirection: 'column',
    marginTop: 144
  },
  address: {
    fontSize: 11,
    color: '#329599',
    textAlign: 'center',
    marginTop: 16,
    fontFamily: 'Helvetica-Oblique'
  }
})

const InvoiceFooter = ({ address }) => (
    <View style={styles.addressContainer}>
      <Text style={styles.address}>{address}</Text>
    </View>
)

export default InvoiceFooter
